// Servicio principal que centraliza todos los sub-servicios
// Este archivo actúa como punto de entrada único para page.tsx

// Importar todos los sub-servicios
import companyDataService from './company/companyDataService.js';
import hierarchyService from './hierarchy/hierarchyService.js';
import metricsInitializerService from './metrics/metricsInitializerService.js';
import basicMetricsService from './metrics/basicMetricsService.js';
import planMetricsService from './metrics/planMetricsService.js';

// Re-exportar todas las funciones para mantener compatibilidad
export const {
  getCompanyById,
  getCompanyMetrics,
  getCompleteDashboardMetrics,
  getDrillDownMetrics
} = companyDataService;

export const {
  getCompanyHierarchy,
  getDrillDownData
} = hierarchyService;

export const {
  initializeCompanyMetrics,
  initializeAllCompaniesMetrics
} = metricsInitializerService;

export const {
  calculateBasicMetrics
} = basicMetricsService;

export const {
  calculatePlanMetrics
} = planMetricsService;

// Objeto de servicio principal para compatibilidad con importaciones existentes
const companyHierarchyService = {
  // Servicios de datos de compañía
  getCompanyById,
  getCompanyMetrics,
  getCompleteDashboardMetrics,
  getDrillDownMetrics,
  
  // Servicios de jerarquía
  getCompanyHierarchy,
  getDrillDownData,
  
  // Servicios de inicialización de métricas
  initializeCompanyMetrics,
  initializeAllCompaniesMetrics,
  
  // Servicios de cálculo de métricas
  calculateBasicMetrics,
  calculatePlanMetrics,

  // Agregar la función faltante
  async getHistoricalMetrics(companyId, dateRange = null) {
    // Reutilizar la lógica existente
    const dashboardData = await getCompleteDashboardMetrics(companyId, dateRange);
    return dashboardData?.historical || null;
  }
};

// Clase para compatibilidad con importaciones existentes
export class CompanyHierarchyService {
  static async getHistoricalMetrics(companyId, dateRange = null) {
    const dashboardData = await getCompleteDashboardMetrics(companyId, dateRange);
    return dashboardData?.historical || null;
  }

  static async getCompanyById(companyId) {
    return getCompanyById(companyId);
  }

  static async getCompanyHierarchy(companyId) {
    return getCompanyHierarchy(companyId);
  }

  static async getCompanyMetrics(companyId) {
    return getCompanyMetrics(companyId);
  }

  static async getCompleteDashboardMetrics(companyId, dateRange = null) {
    return getCompleteDashboardMetrics(companyId, dateRange);
  }

  static async getDrillDownMetrics(companyId, level, parentId = null) {
    return getDrillDownMetrics(companyId, level, parentId);
  }

  static async initializeCompanyMetrics(companyId) {
    return initializeCompanyMetrics(companyId);
  }

  static async initializeAllCompaniesMetrics() {
    return initializeAllCompaniesMetrics();
  }

  static async getDrillDownData(companyId, level, parentId = null) {
    return getDrillDownData(companyId, level, parentId);
  }

  static async calculateBasicMetrics(companyId) {
    return calculateBasicMetrics(companyId);
  }

  static async calculatePlanMetrics(companyId) {
    return calculatePlanMetrics(companyId);
  }
}

// Exportaciones para compatibilidad
export { companyHierarchyService };
export default companyHierarchyService;